<template style="height:100%">
  <div>
    <div class="trackarchives"  v-bind:class="[isActive ? activeClass : errorClass]">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-form-item label="姓名2">
                <el-input v-model="formInline.user" placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item label="账号">
                <el-input v-model="formInline.user" placeholder="账号"></el-input>
              </el-form-item>
              <el-form-item label="测试时间">
                <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="cvbb" style="width:260px">
                <el-button type="primary" @click="onSubmit">筛选</el-button>
                <el-button type="primary" @click="onSubmit">重置条件</el-button>
              </el-form-item>
            </el-form>
        </div>
        <div class="Thelist">
          <el-button type="primary" @click="onSubmit">导出全部量表</el-button>
          <el-button type="primary" plain>批量删除</el-button>
          <!-- <el-button type="primary" @click="onSubmit">批量删除</el-button> -->
              <el-table :data="tableData"  style="width: 100%;margin-top:10px;" :default-sort = "{prop: 'date', order: 'descending'}" >
                <el-table-column  type="selection"  width="55"> </el-table-column>
                <el-table-column v-if="panduan[0]" prop="date" :label="header[0]" sortable width="180">
                   <!-- <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <i>姓名: {{ scope.row.date }}</i>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.date }}
                      </div>
                    </el-popover>
                  </template> -->
                </el-table-column>
                <el-table-column v-if="panduan[2]"  prop="name" :label="header[1]" sortable width="180">
                </el-table-column>
                <el-table-column show-overflow-tooltip style="width: 100px"  prop="address" :label="header[2]" :formatter="formatter">
                  <!-- <template slot-scope="scope" style="width: 100px">
                    <el-popover trigger="hover" placement="top">
                      <i>地址: {{ scope.row.address }}</i>
                      <div slot="reference" class="name-wrapper">
                        {{ scope.row.address }}
                      </div>
                    </el-popover>
                  </template> -->
                </el-table-column>
                <el-table-column  prop="cs" :label="header[3]" :formatter="formatter">
                </el-table-column>
                <el-table-column v-if="panduan[0]" prop="date" :label="header[0]" sortable width="180">
                </el-table-column>
                <el-table-column v-if="panduan[2]"  prop="name" :label="header[1]" sortable width="180">
                </el-table-column>
                <el-table-column  prop="address" :label="header[2]" :formatter="formatter">
                </el-table-column>
                <el-table-column  prop="cs" :label="header[3]" :formatter="formatter">
                   <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span style="margin-left: 10px">{{ scope.row.date }}</span>
                    </template>
                </el-table-column>
              </el-table>
        </div>

  </div>
</template>
<script>
import Notest from './Notest'

  export default {
    data() {
      return {
        ccfd:true,
        header:["c日s期","姓sc名", "地sc址", "cddddds"],
        panduan:[1,1,1,1],
        activeNames: ['1'],
        activeName: 'second',
        input1:'',
        value1:'',
        isActive: true,
        activeClass: 'trackarchives',
        errorClass: 'trackarchives2',
        formInline: {
          user: '',
          region: ''
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀 1575518 弄',
          cs: '上弄',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀 1515578 弄',
          cs: '上弄',
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普 155417 弄',
          cs: '上弄',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀157718 弄',
          cs: '上弄',
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区165519 弄',
          cs: '上弄',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区 151528 弄',
          cs: '上弄',
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀 151256 弄',
          cs: '上弄',
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普路 151252 弄',
          cs: '上弄',
        }],
        checkboxGroup1: [],
     
        };
    },
    components:{
      Notest,
    },
    methods: {
      handleChange(val) {
      },
      change(){
        this.isActive = !this.isActive;
      },
      onSubmit(){
      },
      handleEdit(index, row) {
      },
      handleDelete(index, row) {
      }
    }
  };
</script>

<style>
.Test{height: 100%;position: relative;background-color: #fff;}
.Test .el-tabs__nav-scroll{border: 1px solid #e3e3e3;padding-left: 16px;}
.Test .el-tabs__header {margin: 0 0 0px;}
input{width: 300px;}
.Test .el-form--inline .el-form-item {width: 31.5%;}
.Test .el-form-item__content{width: 75%;}
.Test .el-select{width: 75%;}
.Test  .el-form-item__label{width: 70px;text-align: right;}
.Test .el-date-editor{width: 100%;}
.Test .cvde{width: 60%!important;}
.trackarchives{height: 106px;position: relative;border: 1px solid #e3e3e3;padding-top: 20px;padding: 16px;}
.trackarchives2{height: 300px;position: relative;border: 1px solid #e3e3e3;padding-top: 20px;padding: 16px;}
.change{width: 40px;margin-left: -80px;display: inline-block;height: 22px;margin-top: 22px;position: absolute;z-index: 10;cursor:pointer;color: #5e5a5a;}
.Test .cvbb{margin-bottom: 30px;}
.Test  .Thelist{padding: 16px;background-color: #fff;min-height: 480px;border: 1px solid #e3e3e3;margin-top: 20px;}
.el-tooltip__popper{max-width:20%;}
.el-tooltip__popper,.el-tooltip__popper.is-dark{background:#f5f5f5 !important;
  color: #303133 !important;}
</style>